import { styled } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

export const VERIFIED_TOLLFREE_JOTFORM_FORM_ID = "212927412322044";

const JotformWrapper = styled("div")({
  transition: "0.5s all",
  height: "100%",
  display: "flex",
});

export function getJotformURL(
  formId: string,
  addtlParams: Record<string, any>
): string {
  const urlParams = new URLSearchParams({
    currentSpoke: `https://${document.location.host}`,
    ...addtlParams,
  });

  return `https://form.jotform.com/${formId}?${urlParams.toString()}`;
}

export default function Jotform({
  formId,
  urlParams = {},
}: {
  formId: string;
  urlParams?: Record<string, any>;
}): ReactElement {
  const [iframeIsLoading, setIframeIsLoading] = useState(true);

  useEffect(() => {
    function handleWindowMessage(msg: any) {
      // To figure out when the Jotform has loaded, we snoop on the messages
      // being posted from the iframe back to this window. When we see the
      // "setHeight" message, that means the Jotform has loaded.
      if (!msg.data || typeof msg.data !== "string") {
        // no data attached to the message; probably not a Jotform message
        return;
      }

      const msgParts = msg.data.split(":");
      if (msgParts[2] !== formId) {
        // Not a Jotform message
        return;
      }

      if (msgParts[0] === "setHeight") {
        // This is the message we're waiting for
        setIframeIsLoading(false);
      }
    }

    window.addEventListener("message", handleWindowMessage);

    // Because this relies on listening to undocumented message, we also have
    // this backup so we don't get stuck on the loading screen if the message
    // format changes.
    const timeoutHandle = setTimeout(() => {
      setIframeIsLoading(false);
    }, 10 * 1000);

    return () => {
      window.removeEventListener("message", handleWindowMessage);
      clearTimeout(timeoutHandle);
    };
  }, [formId]);

  return (
    <JotformWrapper sx={{ opacity: iframeIsLoading ? 0 : 1 }}>
      <iframe
        src={getJotformURL(formId, urlParams)}
        title="JotForm Form"
        allowFullScreen={true}
        style={{
          overflow: "hidden",
          border: 0,
          width: "100%",
          flexGrow: 1,
        }}
      />
    </JotformWrapper>
  );
}
